// src/pages/Orders.tsx
import React from 'react';
import OrdersTable from '../components/tables/OrdersTable';

const Orders: React.FC = () => {
  return (
    <div 
      className="container mx-auto px-4 py-4 overflow-visible"
      style={{ height: '-webkit-fill-available' }}
    >
      <OrdersTable />
    </div>
  );
};

export default Orders;
